'use client';
import { useEffect } from 'react';
import clsx from 'clsx';

import { logEvent } from '../../lib/analytics';

import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { AlertOctagon } from '../icons/alertOctagon';

import { DownloadAudio } from './DownloadAudio';
import { Editor } from './Editor';
import { EditorHeader } from './EditorHeader';
import { PlayButton } from './Player';
import { UpsellModal } from './UpsellModal';
import { VoiceList } from './VoiceList';

import styles from './styles.module.css';
import { LanguageSelector } from './languageSelector';
import { useVoices } from '../../providers/VoicesProvider';
import { useIsMobileDevice } from '../../lib/utils';

export const VoiceDemo = () => {
  const { error, audioGenerationLimit, isFeatureFlagLoading } = useVoiceDemo();
  const { voices: allVoicesData } = useVoices();
  const isMobile = useIsMobileDevice();
  useEffect(() => {
    // this is logged as vo_demo_visited on amplitude
    logEvent('visited', {});
  }, []);
  useEffect(() => {
    if (isFeatureFlagLoading) return;
    logEvent('ab_test_variant_assigned', {
      testName: 'audioGenerationLimit',
      variant: audioGenerationLimit,
    });
  }, [isFeatureFlagLoading, audioGenerationLimit]);
  return (
    <div
      className="font-ABCDiatype text-glass-800 relative flex w-full max-w-[900px] flex-col gap-4 rounded-[32px] bg-white p-4 @sm:p-6"
      data-testid="voice-demo">
      <div className="flex flex-wrap items-center justify-between gap-4 @md:items-start">
        <div className="flex w-full justify-between gap-2 @sm:w-auto">
          <VoiceList />
          {isMobile && <LanguageSelector allLanguages={allVoicesData} />}
        </div>
        {!isMobile && (
          <div className="flex w-full gap-2 @sm:w-auto">
            <PlayButton />
            <DownloadAudio />
          </div>
        )}
      </div>
      <div className="mx-[-16px] hidden h-px bg-[#F5F5FA] @sm:mx-[-24px] @sm:block" />
      <div className="flex flex-col @lg:flex-row @lg:gap-4">
        <div className={clsx('mb-2 flex-1 xl:w-11/12', styles.textAreaWrapper)}>
          <Editor />
        </div>
      </div>
      {isMobile && (
        <div className="flex w-full gap-2 @sm:w-auto">
          <PlayButton />
          <DownloadAudio />
        </div>
      )}
      {!isMobile && <EditorHeader />}
      <UpsellModal />
      {error && (
        <p
          role="alert"
          className="absolute left-1/2 top-8 z-50 flex -translate-x-2/4 items-center gap-4 rounded-2xl bg-[#0000007f] p-4 text-white backdrop-blur-sm @lg:w-fit">
          <AlertOctagon className="text-xl text-[#FF4B40]" />
          {error.message}
        </p>
      )}
    </div>
  );
};
